import crochet_in_dti from "../../assets/gallery/crochets/crochet_in_dti.png";
import hairband_blue from "../../assets/gallery/crochets/hairband_blue.png";
import hat from "../../assets/gallery/crochets/hat.png";
import polarcase from "../../assets/gallery/crochets/polarcase.png";
import crochet_umass from "../../assets/gallery/crochets/crochet_umass.png";
import leaf1 from "../../assets/gallery/crochets/leaf1.png";
import sc from "../../assets/gallery/crochets/sc.png";
import poster from "../../assets/gallery/crochets/poster.png";
import leaf2 from "../../assets/gallery/crochets/leaf2.png";
import scarf from "../../assets/gallery/crochets/scarf.png";
import flower_gift from "../../assets/gallery/crochets/flower_gift.png";
import bag1 from "../../assets/gallery/crochets/bag1.png";
import bag2 from "../../assets/gallery/crochets/bag2.png";
import bag3 from "../../assets/gallery/crochets/bag3.png";
import tooth from "../../assets/gallery/crochets/tooth.png";
import spiederman from "../../assets/gallery/crochets/spiederman.png";
import hairband_green from "../../assets/gallery/crochets/hairband_green.png";
import compcase from "../../assets/gallery/crochets/compcase.png";
import pumpkin from "../../assets/gallery/crochets/pumpkin.png";
import smile from "../../assets/gallery/crochets/smile.png";
import fish from "../../assets/gallery/crochets/fish.png";
import rainbow from "../../assets/gallery/crochets/rainbow.png";

const DataCrochets = [
	{src:crochet_in_dti, name:crochet_in_dti},
	{src:hairband_blue, name:hairband_blue},
	{src:hat, name:hat},
	{src:polarcase, name:polarcase},
	{src:crochet_umass, name:crochet_umass},
	{src:leaf1, name:leaf1},
	{src:sc, name:sc},
	{src:poster, name:poster},
	{src:leaf2, name:leaf2},
	{src:scarf, name:scarf},
	{src:flower_gift, name:flower_gift},
	{src:bag1, name:bag1},
	{src:bag2, name:bag2},
	{src:bag3, name:bag3},
	{src:tooth, name:tooth},
	{src:spiederman, name:spiederman},
	{src:hairband_green, name:hairband_green},
	{src:compcase, name:compcase},
	{src:pumpkin, name:pumpkin},
	{src:smile, name:smile},
	{src:fish, name:fish},
	{src:rainbow, name:rainbow},
]

export default DataCrochets;